import DashboardsIcon from 'assets/dualicons/dashboards.svg?react';
import { NAV_TYPE_ITEM } from 'constants/app.constant';

import {
  ChartBarIcon,
  ChartBarSquareIcon,
  ClipboardDocumentIcon,
  DeviceTabletIcon,
  ShareIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/24/outline';

// --- Dashboard Navigation Item ---
const dashboards = {
  id: 'dashboards',
  type: NAV_TYPE_ITEM,
  path: '/dashboard',
  title: 'Dashboards',
  transKey: 'nav.dashboards.dashboards',
  Icon: DashboardsIcon,
};

// --- Analytics (Climate) Navigation Item ---
const climateAnalytics = {
  id: 'analytics',
  type: NAV_TYPE_ITEM,
  path: '/analytics',
  title: 'Climate',
  transKey: 'nav.dashboards.analytics',
  Icon: ChartBarSquareIcon,
};

// --- Devices Navigation Group ---
const devices = {
  id: 'devices',
  type: NAV_TYPE_ITEM,
  path: '/devices',
  title: 'Device Managements',
  transKey: 'nav.dashboards.deviceManagement',
  Icon: DeviceTabletIcon,
  childs: [
    {
      id: 'devices.informations',
      path: 'devices/information',
      type: NAV_TYPE_ITEM,
      title: 'Information',
      transKey: 'nav.dashboards.information',
      Icon: DeviceTabletIcon,
    },
    {
      id: 'devices.calibration',
      path: 'devices/calibration',
      type: NAV_TYPE_ITEM,
      title: 'Calibration',
      transKey: 'nav.dashboards.calibration',
      Icon: DeviceTabletIcon,
    },
  ],
};

// --- Reports Navigation Group ---
const reports = {
  id: 'reports',
  type: NAV_TYPE_ITEM,
  path: '/reports',
  title: 'Analytics and Reporting',
  transKey: 'nav.dashboards.analyticsReports',
  Icon: ChartBarIcon,
  childs: [
    // {
    //   id: 'reports.analytics',
    //   path: 'reports/analytics',
    //   type: NAV_TYPE_ITEM,
    //   title: 'Analytics',
    //   transKey: 'nav.dashboards.analytics',
    //   Icon: ChartBarIcon,
    // },
    {
      id: 'reports.periodic_analysis',
      path: 'reports/periodic-analysis',
      type: NAV_TYPE_ITEM,
      title: 'Periodic Analysis',
      transKey: 'nav.dashboards.periodic_analysis',
      Icon: ChartBarIcon,
    },
    {
      id: 'reports.daily-profile',
      path: 'reports/daily-profile',
      type: NAV_TYPE_ITEM,
      title: 'Daily Profile',
      transKey: 'nav.dashboards.daily_profile',
      Icon: ChartBarIcon,
    },
    {
      id: 'reports.seasonal-analysis',
      path: 'reports/seasonal-analysis',
      type: NAV_TYPE_ITEM,
      title: 'Seasonal Analysis',
      transKey: 'nav.dashboards.seasonal_analysis',
      Icon: ChartBarIcon,
    },
    {
      id: 'reports.weather',
      path: 'reports/weather',
      type: NAV_TYPE_ITEM,
      title: 'Weather',
      transKey: 'nav.dashboards.weather',
      Icon: ChartBarIcon,
    },
    {
      id: 'reports.annual',
      path: 'reports/annual',
      type: NAV_TYPE_ITEM,
      title: 'Annual',
      transKey: 'nav.dashboards.annual',
      Icon: ChartBarIcon,
    },
    {
      id: 'reports.correlation_analysis',
      path: 'reports/correlation-analysis',
      type: NAV_TYPE_ITEM,
      title: 'Correlation Analysis',
      transKey: 'nav.dashboards.correlation_analysis',
      Icon: ChartBarIcon,
    },
  ],
};

// --- Alerts Navigation Item ---
const alerts = {
  id: 'alerts',
  type: NAV_TYPE_ITEM,
  path: '/alerts',
  title: 'Alerts',
  transKey: 'nav.dashboards.alerts',
  Icon: ClipboardDocumentIcon,
};

// --- Data Sharing Navigation Item ---
const dataSharing = {
  id: 'dataSharing',
  type: NAV_TYPE_ITEM,
  path: '/datasharing',
  title: 'Data Sharing',
  transKey: 'nav.dashboards.dataSharing',
  Icon: ShareIcon,
};

const help = {
  id: 'help',
  type: NAV_TYPE_ITEM,
  path: '/help',
  title: 'Help',
  transKey: 'nav.system.help',
  Icon: QuestionMarkCircleIcon,
};

// --- Base Navigation ---
export const baseNavigation = [
  dashboards,
  climateAnalytics,
  reports,
  devices,
  alerts,
  dataSharing,
  help,
];
